////////////////////////////
// M034 charter packages

function initCharterPackages() {

    //consolog("initCharterPackages");

    $(".charterPackagesBlockRow").slick({
        responsive: [
            {
                breakpoint: 99999,
                settings: "unslick"
            },
            {
                breakpoint: _breakpointMedium,
                settings: {
                    dots: false,
                    infinite: true,
                    draggable: true,
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '30px',
                    variableWidth: false,
                    adaptiveHeight: true,
                    focusOnSelect: true,
                    prevArrow: slickPrevArrowCode,
                    nextArrow: slickNextArrowCode
                }
            }
        ]
	});

	if($(window).width() > _breakpointMedium){
		$(".charterPackagesBlock").removeAttr("tabindex");
		$(".charterPackagesBlockRow").find("a").attr("tabindex", "0");
	}
	
	//v2
	if($(".charterPackagesSelect").length > 0){
		
		$(".charterPackagesSelectResult").show();		

		//initial setting of val
		$("select.charterPackagesSelect").each(function(){
			var txt = $(this).find("option").first().text();
			//console.log("inital check => txt:" + txt);

			$(this).siblings(".nice-select").children(".current").html(txt);
		});

		//selectbox change handler
		$(".charterPackagesSelect").on("change", function(){
			var $f = $(this).closest(".charterPackagesFooter");
			var $r = $f.find(".charterPackagesSelectResultValue span");
			
			$f.find(".charterPackagesSelectButton").removeClass("disabled");
			
			if($(this).val() != ""){
				
				$f.find(".charterPackagesSelectResult").show();			
				$r.html($(this).val());			
				var url = $(this).find("option:selected" ).attr("data-url");
				$f.find(".charterPackagesSelectButton").attr("href", url);
				//console.log("target url:" + url);
			}
			else{
				$f.find(".charterPackagesSelectResult").hide();
				$f.find(".charterPackagesSelectButton").addClass("disabled");
			}
		});
	}
	
	//v3
	if($(".charterPackagesFooterBlockTable").length > 0){
		$(".charterPackagesFooterBlockTableRow").click(function(){
			//console.log("click row");
			var url = $(this).attr("data-url");
			
			$(".charterPackagesFooterBlockTableRow").removeClass("active");
			$(this).addClass("active");

			var $f = $(this).closest(".charterPackagesFooter");
			$f.find(".charterPackagesSelectButton").attr("href", url);
			$f.find(".charterPackagesSelectButton").removeClass("disabled");
		});
		$(".charterPackagesFooterBlockTableRow").on("keydown", handleKeyDownForClick);
	}
}
